import React, { Component, ReactNode } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

interface DivLinkProps extends RouteComponentProps {
  to: string
  className?: string
  children: ReactNode
  onClick?: () => void
}

class DivLink extends Component<DivLinkProps> {
  constructor (props: DivLinkProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  get className () {
    const base = 'cursor-pointer'
    return `${base} ${this.props.className}`
  }

  handleClick () {
    const { onClick } = this.props
    this.props.history.push(this.props.to)
    if (onClick) onClick()
  }

  render () {
    return (
      <div
        className={this.className}
        onClick={this.handleClick}>
        {this.props.children}
      </div>
    )
  }
}

export default withRouter(DivLink)
